import React from "react";

import { authResponse } from "Utils/authentication";

type Props = React.ElementProps<"form">;

const FormAuthenticityToken = () => {
  const csrfToken = authResponse.currentValue ? authResponse.currentValue.csrfToken : null;
  if (!csrfToken) return null;
  return <input type="hidden" name="authenticity_token" value={csrfToken.value} />;
};

// Creates a form element that includes the required Rails authenticity token.
const Form = ({ method, children, ...rest }: Props) => (
  <form method={method} {...rest}>
    {/^get$|^$/i.test(method) || <FormAuthenticityToken />}
    {children}
  </form>
);

export default Form;
